(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["limited-time-sale"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeSlider = (campaign) => {
      if (campaign.dataset.sliderInitialized === 'true') return;
      campaign.dataset.sliderInitialized = 'true';

      const track = campaign.querySelector('[data-sale-track]');
      const previous = campaign.querySelector('[data-sale-previous]');
      const next = campaign.querySelector('[data-sale-next]');
      const current = campaign.querySelector('[data-sale-current]');
      const total = campaign.querySelector('[data-sale-total]');
      if (!track || !previous || !next) return;

      const cards = [...track.querySelectorAll('.limited-bundle-card')];
      if (total) total.textContent = String(cards.length).padStart(2, '0');
      const hasMultipleCards = cards.length > 1;
      const shouldLoop = hasMultipleCards && !campaign.classList.contains('home-limited-sale--few');
      previous.disabled = !shouldLoop;
      next.disabled = !shouldLoop;
      if (!cards.length) {
        return;
      }

      const cloneCount = shouldLoop ? Math.min(3, cards.length) : 0;
      const createClone = (card) => {
        const clone = card.cloneNode(true);
        clone.classList.add('limited-bundle-card--clone');
        clone.classList.remove('reveal', 'is-in');
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        clone.querySelectorAll('a, button, input').forEach((element) => {
          element.tabIndex = -1;
        });
        clone.querySelectorAll('img').forEach((image) => {
          image.loading = 'eager';
        });
        return clone;
      };

      if (shouldLoop) {
        cards.slice(-cloneCount).reverse().forEach((card) => track.prepend(createClone(card)));
        cards.slice(0, cloneCount).forEach((card) => track.append(createClone(card)));
      }

      const cardStep = () => {
        if (!cards.length) return track.clientWidth;
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return cards[0].getBoundingClientRect().width + gap;
      };

      let physicalIndex = cloneCount;
      let scrollEndTimer;

      const physicalIndexFromScroll = () => {
        return Math.round(track.scrollLeft / cardStep());
      };

      const logicalIndex = (index = physicalIndexFromScroll()) => {
        return ((index - cloneCount) % cards.length + cards.length) % cards.length;
      };

      const jumpToPhysicalIndex = (index) => {
        physicalIndex = index;
        track.scrollTo({ left: index * cardStep(), behavior: 'auto' });
      };

      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        physicalIndex = physicalIndexFromScroll();
        const index = logicalIndex(physicalIndex);
        track.dataset.saleIndex = String(index);
        if (current) current.textContent = String(index + 1).padStart(2, '0');
        previous.disabled = !shouldLoop || maxScroll <= 2;
        next.disabled = !shouldLoop || maxScroll <= 2;
      };

      const normalizePosition = () => {
        physicalIndex = physicalIndexFromScroll();
        if (physicalIndex >= cloneCount + cards.length) {
          jumpToPhysicalIndex(physicalIndex - cards.length);
        } else if (physicalIndex < cloneCount) {
          jumpToPhysicalIndex(physicalIndex + cards.length);
        }
        update();
      };

      const move = (direction) => {
        if (!shouldLoop) return;
        physicalIndex = physicalIndexFromScroll() + direction;
        track.scrollTo({
          left: physicalIndex * cardStep(),
          behavior: 'smooth',
        });
      };

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let autoplayTimer;
      const stopAutoplay = () => window.clearTimeout(autoplayTimer);
      const startAutoplay = () => {
        stopAutoplay();
        if (!shouldLoop || reduceMotion || document.hidden || campaign.matches(':hover') || campaign.contains(document.activeElement) || campaign.classList.contains('is-expired')) return;
        autoplayTimer = window.setTimeout(() => {
          move(1);
          startAutoplay();
        }, 5000);
      };
      const moveManually = (direction) => {
        move(direction);
        startAutoplay();
      };

      previous.addEventListener('click', () => moveManually(-1));
      next.addEventListener('click', () => moveManually(1));
      track.addEventListener('scroll', () => {
        update();
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(normalizePosition, 140);
      }, { passive: true });
      campaign.addEventListener('mouseenter', stopAutoplay);
      campaign.addEventListener('mouseleave', startAutoplay);
      campaign.addEventListener('focusin', stopAutoplay);
      campaign.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!campaign.contains(document.activeElement)) startAutoplay();
        }, 0);
      });
      track.addEventListener('pointerdown', stopAutoplay, { passive: true });
      track.addEventListener('pointerup', startAutoplay, { passive: true });
      track.addEventListener('pointercancel', startAutoplay, { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });
      window.addEventListener('resize', () => {
        jumpToPhysicalIndex(cloneCount + logicalIndex(physicalIndex));
        update();
      }, { passive: true });
      jumpToPhysicalIndex(cloneCount);
      update();
      startAutoplay();
    };

    const initializeCampaign = (campaign) => {
      if (campaign.dataset.countdownInitialized === 'true') return;
      campaign.dataset.countdownInitialized = 'true';

      if (campaign.dataset.saleActive !== 'true') return;

      const deadlineElement = campaign.querySelector('[data-sale-deadline]');
      const timerElement = campaign.querySelector('[data-sale-timer]');
      const expiredElement = campaign.querySelector('[data-sale-expired]');
      const exactDateElement = campaign.querySelector('[data-sale-end-date]');
      const deadline = Date.parse(campaign.dataset.saleEnd || '');

      if (!Number.isFinite(deadline)) {
        if (deadlineElement) deadlineElement.hidden = true;
        return;
      }

      if (exactDateElement) {
        exactDateElement.dateTime = new Date(deadline).toISOString();
        exactDateElement.textContent = new Intl.DateTimeFormat('en-PK', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          timeZone: 'Asia/Karachi',
          timeZoneName: 'short',
        }).format(deadline);
      }

      const outputs = {
        days: campaign.querySelector('[data-sale-days]'),
        hours: campaign.querySelector('[data-sale-hours]'),
        minutes: campaign.querySelector('[data-sale-minutes]'),
        seconds: campaign.querySelector('[data-sale-seconds]'),
      };

      let interval;
      const update = () => {
        const remaining = deadline - Date.now();
        if (remaining <= 0) {
          campaign.classList.add('is-expired');
          if (timerElement) timerElement.hidden = true;
          if (expiredElement) expiredElement.hidden = false;
          window.clearInterval(interval);
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60,
        };

        Object.entries(values).forEach(([key, value]) => {
          if (outputs[key]) outputs[key].textContent = String(value).padStart(2, '0');
        });
      };

      update();
      if (campaign.classList.contains('is-expired')) return;
      interval = window.setInterval(update, 1000);
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-limited-sale]').forEach((campaign) => {
        initializeSlider(campaign);
        initializeCampaign(campaign);
      });
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
